import type { ICreateApiVersionCmd } from "@/data/commands/system/CreateApiVersionCmd";
import { Factory } from "@/data/dao/Factory";
import { SystemDao } from "@/data/dao/service/SystemDao";
import type { IApiVersion } from "@/data/model/System";

import { FileUpload } from "@/portal/formControls/FileUpload";
import { BaseEntityForm } from "@/portal/forms/BaseEntityForm";

export class ApiVersionForm extends BaseEntityForm<IApiVersion, ICreateApiVersionCmd> {
    private $nameField: JQuery;
    private $versionField: JQuery;
    private filePicker: FileUpload;

    constructor(element: JQuery) {
        super(element, Factory.getInstance<SystemDao>(SystemDao).apiVersionDataSource);

        this.$nameField = this.$form
            .find('.form-control[name="name"]')
            .change(() => this.updateName(this.$nameField.val()));
        this.$versionField = this.$form.find('.form-control[name="version"]');
        this.filePicker = new FileUpload({
            allowedTypes: ["zip", "rar", "application/octet-stream"],
            maxFileSizeInBytes: 5 * 1000000, //mb
        }).renderTo(this.$form.find("#packageupload > .col-lg-9"));
    }

    public setFormData(model?: IApiVersion) {
        this.updateName(model === undefined ? "" : model.name);
        this.$nameField.val(model === undefined ? "" : model.name);
        this.$versionField.val(model === undefined ? "" : model.version);
        this.filePicker.setValue(model === undefined ? undefined : model.package);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public getFormData($form: JQuery): ICreateApiVersionCmd {
        const data = {
            name: this.$nameField.val().length > 0 ? this.$nameField.val() : undefined,
            version: this.$versionField.val().length > 0 ? this.$versionField.val() : undefined,
            package: this.filePicker.getValue(),
        };

        if (this.filePicker.needsRemoval()) data["removePackage"] = true;

        let hasError = false;

        if (data.name === undefined) {
            hasError = true;
            this.$nameField.addClass("is-invalid");
        }

        if (data.version === undefined || !/^\d(\.\d)*$/g.test(data.version)) {
            hasError = true;
            this.$versionField.addClass("is-invalid");
        }

        return (hasError ? undefined : data) as any;
    }
}
